import React, {Component} from 'react';
// import _ from 'lodash';
import {connect} from 'react-redux';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from "react-router-dom";
import { PUBLIC_URL } from '../../config';
import line_logo from '../../assets/img/beautrium/social_logo/line_logo.png';
import fb_logo from '../../assets/img/beautrium/social_logo/fb_logo.png';
import twitter_logo from '../../assets/img/beautrium/social_logo/twitter_logo.png';
import { blogShare } from '../../actions/blog/index';

class ShareSideBar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            
        }
        this.fbShare = this.fbShare.bind(this);
        this.lineShare = this.lineShare.bind(this);
        this.twitterShare = this.twitterShare.bind(this);
        this.handleShare = this.handleShare.bind(this);
    }

    fbShare(url){
        let temp = url.replace("|","")
        /* eslint-disable */
        FB.ui({
            method: 'share',
            href: temp,
        }, function(response){});
        /* eslint-enable */
        this.handleShare('fb_share', this.props.fbShare)
    }

    lineShare(url){
        let temp = `https://social-plugins.line.me/lineit/share?url=${url}`
        window.open(temp, null, "width=503,height=510,left=50%,top=50%,resizable=yes,scrollbars=no,chrome=yes,centerscreen=yes")
        this.handleShare('line_share', this.props.lineShare)
    }

    twitterShare(url, title){
        let temp_title = title.replace("|","")
        // https://twitter.com/share?url=https://codepen.io/patrickkahl&amp;text=Share popup on &amp;hashtags=codepen
        let temp = `https://twitter.com/intent/tweet?text=${temp_title+" "+url}&amp;hashtags=BEAUTRIUM`
        // let temp = `https://twitter.com/share?url=${url}&amp;text=${title}&amp;hashtags=BEAUTRIUM`
        console.log(url, title, temp)
        window.open(temp, null, "width=503,height=510,left=50%,top=50%,resizable=yes,scrollbars=no,chrome=yes,centerscreen=yes")
        this.handleShare('twitter_share', this.props.twitterShare)
    }

    handleShare(platform, share){
        this.props.blogShare(this.props.blogUrl ,platform , share, this.props.totalShare)
    }

    render() {
        const { blogTitle, totalShare } = this.props
        const pathname = this.props.location.pathname
        let shareURL = PUBLIC_URL+pathname
        let encodeShareURL = encodeURIComponent(shareURL)
        return (
            <div className="row social-sidebar d-none d-md-flex">
                <div className="social-logo-holder-sidebar" style={{backgroundColor:"#EEE"}}>
                    {totalShare <= 1 
                    ?   <h4 style={{marginTop:"10px"}}>{totalShare} <span style={{fontSize: "13px", display:"block"}}>Share</span></h4>
                    :   <h4 style={{marginTop:"10px"}}>{totalShare} <span style={{fontSize: "12px", display:"block"}}>Shares</span></h4>
                    }     
                </div>
                <div className="social-logo-holder-sidebar facebook" onClick={(e) => {e.preventDefault(); this.fbShare(shareURL)}}>
                    <img alt="" src={fb_logo} style={{width:"55%", marginLeft:"7px",marginTop:"9px"}}></img>
                </div>
                <div className="social-logo-holder-sidebar twitter"  onClick={(e) => {e.preventDefault(); this.twitterShare(encodeShareURL, blogTitle)}}>
                    <img alt="" src={twitter_logo} style={{width:"70%", marginLeft:"7px",marginTop:"7px"}}></img>
                </div>
                <div className="social-logo-holder-sidebar line" onClick={(e) => {e.preventDefault(); this.lineShare(shareURL)}}>
                    <img alt="" src={line_logo} style={{width:"61%", marginLeft:"9px",marginTop:"8px"}}></img>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
    }
}
export default withRouter(connect(mapStateToProps, {blogShare})(ShareSideBar))